import {getRequest, paramsPostRequest} from "@/utils/request";
import {dataPostRequest} from "../../utils/request";
import da from "element-ui/src/locale/lang/da";

/**
 * 获取当前登陆用户信息
 * @returns {AxiosPromise}
 * @constructor
 */
export const getUserInfo = () => {
  return getRequest('/getUserInfo');
};

export const getConsumerInfo = () => {
  return getRequest('/getUserInfo');
};


export const getAllConsumerIdAndNickName = () => {
  return getRequest('/consumer/allIdAndNickname');
}

export const getSimplifiedConsumerInfo = (data) => {
  return dataPostRequest('/consumer/search', data);
}

export const updateConsumer = (data) => {
  return dataPostRequest('/consumer/update', data);
}

export const addConsumer = (data) => {
  return dataPostRequest('/consumer/add', data);
}

export const deleteConsumer = (params) => {
  return getRequest('/consumer/delete/' + params);
}




// WEBPACK FOOTER //
// ./src/api/consumer/consumerApi.js